// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__z5Ww9","ttl":"styles_ttl__HR0hy","faqList":"styles_faqList__GwNJo","contact":"styles_contact__3yNUY"};